import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum MagicMindPackingSlipLineItemKeys {
  itemName = 'itemName',
  description = 'description',
  sku = 'sku',
  shipped = 'shipped',
}

export const magicMindPackingSlipFileDataSchema = yup.object().shape({
  shipFrom: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  billTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  shipTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  orderNumber: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  deliveryDate: yup.string().nullable().optional(),
  purchaseOrderNumber: yup.string().nullable().optional(),
  showDossLogo: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        [MagicMindPackingSlipLineItemKeys.itemName]: yup.string().nullable().optional(),
        [MagicMindPackingSlipLineItemKeys.description]: yup.string().nullable().optional(),
        [MagicMindPackingSlipLineItemKeys.sku]: yup.string().nullable().optional(),
        [MagicMindPackingSlipLineItemKeys.shipped]: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type MagicMindPackingSlipFileData = yup.InferType<typeof magicMindPackingSlipFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<MagicMindPackingSlipFileData>

export const magicMindPackingSlipFileMappings: RequiredFileData = {
  shipFrom: {
    companyName: '73a60840-ae1c-4dd5-a489-18487b9224aa',
    address: 'c55d8ec7-24a7-4eeb-9d60-2d1911ee01cc',
    contactName: '058cc97c-452b-4d47-b4d6-cf1d3cfa6bb2',
    phoneNumber: 'd01eecd6-1420-42b0-99f9-86cff08a72f4',
    emailAddress: '2f45db6e-c8c0-4a41-9487-ffb4b579c699',
  },
  billTo: {
    companyName: 'af1defc1-3fec-460d-bcfa-a3944523d220',
    address: '601e87ec-2d50-4d1f-b83e-da5b07b073b7',
    contactName: '1c1b2cf2-5316-48be-a25c-2dfcc83e7827',
    phoneNumber: '10ccbb66-0d87-4097-b65d-1ec948a6bdce',
    emailAddress: 'e1780512-486c-4bb3-8c19-4dd53e3124ae',
  },
  shipTo: {
    companyName: 'eef7ded7-22ac-4a07-a3d3-e391dbc4bb51',
    address: '10db5c16-3ebe-4946-98be-1406bef21629',
    contactName: 'edb2a5e7-1bf9-492d-999e-1ae56cb42cf8',
    phoneNumber: 'f7898709-8abc-4ad4-84c0-c48ea16accc8',
    emailAddress: 'd9363d55-ce73-4b9b-a9a0-e214f3184744',
  },
  orderNumber: '4076121f-ee27-44f8-9f04-bba4b1baa2a0',
  date: '20308715-d25d-48c2-b310-5cf9003f0086',
  deliveryDate: 'f4c1837f-e895-4f76-a75f-d73cfdc7344a',
  purchaseOrderNumber: '445d5f99-c57c-47b8-86cc-2bcedc4ae2ff',
  showDossLogo: '502d8cc1-5c2c-4576-aab2-e1a01a604f58',
  items: [
    {
      itemName: 'e8cc164e-117d-427f-8736-d9dac79feefd',
      description: '2b79b6e8-334c-4d84-8a64-f0de8c575d6b',
      sku: '59bb9952-e2c6-4aff-b248-79cdc1b60cd7',
      shipped: '9252e850-80b4-47c7-926c-20bb1e985709',
    },
  ],
}
